export const aciClimatizedPool = {
    iconName: 'climatized-pool',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M10.229 3.12a2.222 2.222 0 013.793 1.57v6.486a3.083 3.083 0 11-4.444 0V4.69c0-.59.234-1.155.65-1.571zm1.57.349a1.222 1.222 0 00-1.221 1.222v6.697a.5.5 0 01-.167.372 2.083 2.083 0 102.777 0 .5.5 0 01-.166-.372V4.69A1.222 1.222 0 0011.8 3.469z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M11.803 4.191a.5.5 0 01.5.5v7.749a.5.5 0 11-1 0V4.691a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M10.84 12.336a1.361 1.361 0 111.925 1.925 1.361 1.361 0 01-1.925-1.925zm.962.601a.36.36 0 100 .722.36.36 0 000-.722z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M18.354 18.912c-1.384.295-2.244-1.119-2.244-1.119a2.459 2.459 0 01-.857.839 2.39 2.39 0 01-1.143.323 2.078 2.078 0 01-1.071-.324 2.144 2.144 0 01-.76-.838 2.936 2.936 0 01-.96.826c-.376.2-.789.315-1.211.337a2.503 2.503 0 01-1.135-.338 2.57 2.57 0 01-.863-.825S7 19.233 5.646 18.935M18.354 21.525c-1.384.295-2.244-1.119-2.244-1.119a2.457 2.457 0 01-.857.839 2.39 2.39 0 01-1.143.324 2.077 2.077 0 01-1.071-.325 2.143 2.143 0 01-.76-.838 2.935 2.935 0 01-.96.826c-.376.2-.789.316-1.211.337a2.503 2.503 0 01-1.135-.338 2.57 2.57 0 01-.863-.825S7 21.846 5.646 21.55',
                    stroke: 'currentColor',
                    'stroke-width': '.9',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
